import type { ExplodedCommentModel } from '../../../../services/api/models/CommentModel';
import type { CommentModelCreateRequestDTO } from '../../../../services/api/models/CommentModelCreateRequestDTO';

export class CreateComment {
  static readonly type = '[MultiView] createComment';
  constructor(public readonly comment: CommentModelCreateRequestDTO) {}
}

export class UpdateComment {
  static readonly type = '[MultiView] updateComment';
  constructor(public readonly comment: CommentModelCreateRequestDTO) {}
}

export class DeleteComment {
  static readonly type = '[MultiView] deleteComment';
  constructor(public readonly id: string) {}
}

export class CommentCallSUCCESS {
  static readonly type = '[MultiView] CommentCallSUCCESS';
}

export class GetChannelComments {
  static readonly type = '[MultiView] getChannelComments';
  constructor(public readonly channelId: string) {}
}

export class RefreshAllComments {
  static readonly type = '[MultiView] refreshAllComments';
}

export class ToggleCommentShowLane {
  static readonly type = '[MultiView] toggleShowLane';
  constructor(public readonly comment: ExplodedCommentModel) {}
}

export class ToggleCommentShowLaneLocal {
  static readonly type = '[MultiView] toggleShowLaneLocal';
  constructor(
    public readonly commentId: string,
    public readonly skipEcharts = false
  ) {}
}
